module.exports = "https://cdn.realtymogul.com/static/media/Trevor_S.ef857a32.jpg";